import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveComponent as _resolveComponent, mergeProps as _mergeProps, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("a", {
  href: "https://anyway.fm/",
  style: {"text-decoration":"none","color":"inherit"}
}, "企业微信报表", -1)
const _hoisted_2 = /*#__PURE__*/_createTextVNode("保存")

import { defineComponent, ref, reactive, nextTick, onMounted } from 'vue';
import request from '@/plugin/request';
import linq from 'linq'

import { VxeGridInstance, VxeGridProps, VxeFormProps, VxeFormInstance } from 'vxe-table'

import { NPageHeader, NButton, NDropdown, NSpace, NBreadcrumb, NBreadcrumbItem, NStatistic, NAvatar, NGrid, NGi } from 'naive-ui'
import { useRoute, useRouter } from "vue-router"


export default _defineComponent({
  setup(__props) {

nextTick(() => {

})



onMounted(() => {

    request('/finereport/dict', {}, { method: 'get' }).then(response => selectOptions.superviseList = response.result.superviseList)

    handleReload()

})

const route = useRoute();
const router = useRouter();

const handleBack = () => {
    router.go(-1)
}

const handleReload = () => {

    request('/finereport', {}, { method: 'get' }).then(response => {

        if (response.result) {
            const xgrid = grid.value
            xgrid.reloadData(response.result.rows)
        }

    })

}

const grid = ref({} as VxeGridInstance)
const gridOptions = reactive<VxeGridProps>({
    align: 'center',
    columns: [
        { type: 'seq', width: 60, fixed: 'left' },
        { field: 'userName', title: '名称', minWidth: 160 },
        { field: 'mobile', title: '手机', minWidth: 160 },
        { field: 'permission', title: '数据权限', minWidth: 160 },
        { field: 'operation', title: '操作', slots: { default: 'operation' } }
    ],
    toolbarConfig: {
        custom: true,
        slots: {
            buttons: 'toolbar_buttons',
            tools: 'toolbar_tools'
        }
    },
    params: {
        toolbar: {
            add: () => {
                modalOptions.form.data = {}
                modalOptions.visible = true
            }
        },
        operation: {
            update: (row: any) => {
                modalOptions.form.data = {}
                modalOptions.form.data = row
                modalOptions.visible = true
            },
            remove: (row: any) => {
                request('/finereport', row, { method: 'DELETE' }).then(response => handleReload())
            }
        }
    }
})

const modalForm = ref({} as VxeFormInstance)
const modalOptions = reactive({
    visible: false,
    form: {
        data: {},
        titleColon: true,
        rules: {
            userName: [{ required: true, message: '必填项' }],
            mobile: [{ required: true, message: '必填项' }],
            permission: [{ required: true, message: '必填项' }],
        }
    } as VxeFormProps,
    method: {
        submit: () => {

            const form = modalForm.value
            form.validate().then(() => {

                request('/finereport', form.data, { method: 'post' }).then(response => {
                    handleReload()
                    modalOptions.visible = false
                })

            })

        },
        close: () => {
            modalOptions.visible = false
        }
    }
})

const selectOptions = reactive({
    superviseList: []
})



return (_ctx: any,_cache: any) => {
  const _component_vxe_button = _resolveComponent("vxe-button")!
  const _component_vxe_grid = _resolveComponent("vxe-grid")!
  const _component_vxe_input = _resolveComponent("vxe-input")!
  const _component_vxe_form_item = _resolveComponent("vxe-form-item")!
  const _component_vxe_option = _resolveComponent("vxe-option")!
  const _component_vxe_select = _resolveComponent("vxe-select")!
  const _component_vxe_form = _resolveComponent("vxe-form")!
  const _component_vxe_modal = _resolveComponent("vxe-modal")!

  return (_openBlock(), _createBlock("div", null, [
    _createVNode(_unref(NPageHeader), {
      subtitle: "权限配置",
      onBack: handleBack
    }, {
      title: _withCtx(() => [
        _hoisted_1
      ]),
      avatar: _withCtx(() => [
        _createVNode(_unref(NAvatar), { src: "https://cdnimg103.lizhi.fm/user/2017/02/04/2583325032200238082_160x160.jpg" })
      ]),
      extra: _withCtx(() => [
        _createVNode(_unref(NSpace), null, {
          default: _withCtx(() => [
            _createVNode(_unref(NButton), { type: "success" }, {
              default: _withCtx(() => [
                _hoisted_2
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_vxe_grid, _mergeProps(_unref(gridOptions), {
      ref: grid,
      style: {"margin-top":"10px"}
    }), {
      toolbar_buttons: _withCtx(() => [
        _createVNode(_component_vxe_button, {
          status: "success",
          size: "mini",
          content: "新增",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(gridOptions).params.toolbar.add()))
        })
      ]),
      toolbar_tools: _withCtx(() => []),
      operation: _withCtx(({ row }) => [
        _createVNode(_component_vxe_button, {
          size: "mini",
          content: "修改",
          status: "warning",
          onClick: ($event: any) => (_unref(gridOptions).params.operation.update(row))
        }, null, 8, ["onClick"]),
        _createVNode(_component_vxe_button, {
          size: "mini",
          content: "删除",
          status: "danger",
          onClick: ($event: any) => (_unref(gridOptions).params.operation.remove(row))
        }, null, 8, ["onClick"])
      ]),
      _: 1
    }, 16),
    _createVNode(_component_vxe_modal, {
      modelValue: _unref(modalOptions).visible,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_unref(modalOptions).visible = $event)),
      width: "50%",
      title: "操作",
      height: "50%"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_vxe_form, _mergeProps(_unref(modalOptions).form, { ref: modalForm }), {
          default: _withCtx(() => [
            _createVNode(_component_vxe_form_item, {
              title: "编码",
              field: "id",
              span: "24",
              "item-render": {}
            }, {
              default: _withCtx(({ data }) => [
                _createVNode(_component_vxe_input, {
                  modelValue: data.id,
                  "onUpdate:modelValue": ($event: any) => (data.id = $event),
                  placeholder: "请输入名称",
                  clearable: "",
                  disabled: ""
                }, null, 8, ["modelValue", "onUpdate:modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_vxe_form_item, {
              title: "名称",
              field: "userName",
              span: "24",
              "item-render": {}
            }, {
              default: _withCtx(({ data }) => [
                _createVNode(_component_vxe_input, {
                  modelValue: data.userName,
                  "onUpdate:modelValue": ($event: any) => (data.userName = $event),
                  placeholder: "请输入名称",
                  clearable: ""
                }, null, 8, ["modelValue", "onUpdate:modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_vxe_form_item, {
              title: "手机",
              field: "mobile",
              span: "24",
              "item-render": {}
            }, {
              default: _withCtx(({ data }) => [
                _createVNode(_component_vxe_input, {
                  modelValue: data.mobile,
                  "onUpdate:modelValue": ($event: any) => (data.mobile = $event),
                  placeholder: "请输入手机",
                  clearable: ""
                }, null, 8, ["modelValue", "onUpdate:modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_vxe_form_item, {
              title: "数据权限",
              field: "permission",
              span: "24",
              "item-render": {}
            }, {
              default: _withCtx(({ data }) => [
                _createVNode(_component_vxe_select, {
                  modelValue: data.permission,
                  "onUpdate:modelValue": ($event: any) => (data.permission = $event),
                  placeholder: "请选择督导",
                  multiple: "",
                  clearable: ""
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_unref(selectOptions).superviseList, (item, index) => {
                      return (_openBlock(), _createBlock(_component_vxe_option, {
                        key: index,
                        value: item.value,
                        label: item.label
                      }, null, 8, ["value", "label"]))
                    }), 128))
                  ]),
                  _: 2
                }, 1032, ["modelValue", "onUpdate:modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_vxe_form_item, {
              align: "center",
              span: "24"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_vxe_button, {
                  status: "primary",
                  content: "提交",
                  onClick: _unref(modalOptions).method.submit
                }, null, 8, ["onClick"]),
                _createVNode(_component_vxe_button, {
                  content: "关闭",
                  onClick: _unref(modalOptions).method.close
                }, null, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 16)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})